import React, { useEffect, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { BellIcon } from '@heroicons/react/24/outline';
import { useChangelog } from '../Changelog/ChangelogProvider';

const HeaderNotifications = ({ isOpen = false, onToggle, variant = 'header' }) => {
  const { t } = useTranslation();
  const {
    allChangelogs,
    loadAllChangelogs
  } = useChangelog();

  useEffect(() => {
    loadAllChangelogs();
  }, [loadAllChangelogs]);

  const hasNewNotifications = useMemo(() => {
    const clickedChangelogIds = JSON.parse(localStorage.getItem('clicked_changelog_ids') || '[]');
    const lastSeenId = parseInt(localStorage.getItem('last_seen_changelog_id') || '0', 10);
    return allChangelogs.some((changelog) => changelog.id > lastSeenId && !clickedChangelogIds.includes(changelog.id));
  }, [allChangelogs]);

  const isSidebar = variant === 'sidebar';

  return (
    <div className="relative">
      <button
        type="button"
        onClick={onToggle}
        className={
          isSidebar
            ? `w-11 h-11 rounded-xl flex items-center justify-center transition-all relative ${
              isOpen
                ? 'bg-white text-gray-900 shadow-sm ring-1 ring-neutral-200'
                : 'text-gray-500 hover:text-gray-900 hover:bg-gray-100'
            }`
            : `h-8 w-8 rounded-full border transition-all flex items-center justify-center relative ${
              isOpen
                ? 'bg-white border-gray-300'
                : 'bg-gray-100 border-gray-200 hover:bg-gray-200'
            }`
        }
        title={t('notifications.notifications')}
        aria-label={t('notifications.notifications')}
      >
        <BellIcon
          className={isSidebar ? 'h-6 w-6' : 'w-4 h-4 text-gray-700'}
          strokeWidth={isSidebar ? 1.5 : 2}
        />
        {hasNewNotifications && (
          <span className="absolute -top-1 -right-1 flex h-2 w-2">
            <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-primary-400 opacity-75" />
            <span className="relative inline-flex rounded-full h-2 w-2 bg-primary-500" />
          </span>
        )}
      </button>
    </div>
  );
};

export default HeaderNotifications;
